import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Flex, Box } from 'rebass/styled-components';

import { Profile } from './steps/profile';
import { useOnboarding } from './hooks/useOnboarding';
import { Stepper } from './components/stepper';
import { NetworkKind } from './steps/networkKinds';
import { Goals } from './steps/goals';
import { LinkedIn } from './steps/linkedin';
import { Team } from './steps/team';

const Walkthrough = () => {
  const {
    isLoadingUpdateUser,
    updateUserProfile,
    handleNextStep,
    goals,
    users,
    setUsers,
    setGoals,
    activeNetwork,
    updateUserGoals,
    isLoadingUpdateUserGoals,
    isLoadingUpdateNetworkKind,
    isLoadingAddAdmin,
    networkKind,
    updateNetworkKind,
    updateGoals,
    user,
    updateTeam,
    showNetworkKindStep,
    profileMode,
  } = useOnboarding();

  return (
    <Box>
      <Stepper
        steps={
          showNetworkKindStep
            ? ['profile', 'network-kind', 'goals', 'linkedin-sync', 'team']
            : ['profile', 'goals', 'linkedin-sync', 'team']
        }
        slug={activeNetwork.slug}
      />
      <Flex
        sx={{
          gap: '56px',
          flexDirection: 'column',
          px: '16px',
          mx: 'auto',
          height: '100%',
        }}
      >
        <Switch>
          <Route exact path="/networks/:networkSlug/welcome/onboarding/profile">
            <Redirect to={`/networks/${activeNetwork.slug}/welcome/onboarding/profile/${profileMode}`} />
          </Route>
          <Route exact path="/networks/:networkSlug/welcome/onboarding/profile/:mode">
            <Profile isLoadingUpdateUser={isLoadingUpdateUser} updateUserProfile={updateUserProfile} />
          </Route>
          <Route exact path="/networks/:networkSlug/welcome/onboarding/network-kind">
            {showNetworkKindStep ? (
              <NetworkKind
                handleNextStep={handleNextStep}
                networkKind={networkKind}
                network={activeNetwork}
                isLoadingUpdateNetworkKind={isLoadingUpdateNetworkKind}
                updateNetworkKind={updateNetworkKind}
              />
            ) : (
              <Redirect to={`/networks/${activeNetwork.slug}/welcome/onboarding/goals`} />
            )}
          </Route>
          <Route exact path="/networks/:networkSlug/welcome/onboarding/goals">
            <Goals
              handleNextStep={handleNextStep}
              goals={goals}
              updateUserGoals={updateUserGoals}
              isLoadingUpdateUserGoals={isLoadingUpdateUserGoals}
              setGoals={setGoals}
              network={activeNetwork}
              updateGoals={updateGoals}
              kind={networkKind}
            />
          </Route>
          <Route exact path="/networks/:networkSlug/welcome/onboarding/linkedin-sync">
            <LinkedIn
              handleNextStep={handleNextStep}
              user={user}
              activeNetwork={activeNetwork}
              networkName={activeNetwork.name}
            />
          </Route>
          <Route exact path="/networks/:networkSlug/welcome/onboarding/team">
            <Team users={users} setUsers={setUsers} isLoadingAddAdmin={isLoadingAddAdmin} updateTeam={updateTeam} />
          </Route>
        </Switch>
      </Flex>
    </Box>
  );
};

export default Walkthrough;
